import React, { FunctionComponent } from "react";

const SingleNeutralProfilePictureIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/users/geomertic-close-up-single-user-neutral/single-neutral-profile-picture
  return (
    <svg
      id="Regular"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 24.5 24.5"
    >
      <defs></defs>
      <title>single-neutral-profile-picture</title>
      <rect
        x="2.25"
        y="0.75"
        width="19.5"
        height="22.5"
        rx="1.5"
        ry="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
      <circle
        cx="12"
        cy="9.083"
        r="4.11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></circle>
      <path
        d="M18.75,19.027a7.63,7.63,0,0,0-13.5,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default SingleNeutralProfilePictureIcon;
